import Cookies from 'js-cookie'
import apiConfig from '../globalConfig/apiConfig'
import { isTargetDomain } from '@praxis/component-auth'
import { getLocation } from '@praxis/runtime-utils/getLocation'

const location = getLocation()

const polDomainRegex = /\.partnersonline\.com/g

const isPOLDomain = (hostName = '') => {
  const polDomain = hostName.match(polDomainRegex)
  return polDomain != null
}

export const isTargetOrPOLDomain = (url) => {
  return isTargetDomain(url) || isPOLDomain(url)
}

const refreshPage = (url) => {
  //Invalid case: Remove token from localstorage will trigger the login route
  localStorage.removeItem('access_token')
  localStorage.removeItem('id_token')
  setTimeout(() => {
    location.assign(url)
  }, 0)
}

//Important note: If the SSOSESSIONINFO cookie ever needs to be inspected, it requires HTTPS.
export const isSSOSessionActive = (loginId = '', hostName = '') => {
  if (isPOLDomain(hostName)) {
    let url = '/'
    const ssoSessionInfo = Cookies.get('SSOSESSIONINFO')
    if (ssoSessionInfo) {
      const { user, login_status } = JSON.parse(window.atob(ssoSessionInfo))
      if (user && login_status && loginId && user === loginId) {
        return true
      } else {
        url = location.href
      }
    } else {
      url = `${apiConfig?.auth?.logoutUrl}?TARGET=${location.href}`
    }
    refreshPage(url)
    return false
  } else {
    return true
  }
}

const authService = { isSSOSessionActive }
export default authService
